var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view",class:{full: _vm.$route.query.hide=='true'}},[(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.loading)?_c('Loading'):_vm._e(),(!_vm.loading&&_vm.$route.params.folder)?_c('div',{staticClass:"content"},[(_vm.osfile.res)?_c('div',{staticClass:"video"},[_c('VideoPlayer',{attrs:{"options":{
        video: {
          url: ("./videos/" + (_vm.osfile.res))
        },
        subtitle: {
          url: ("./data/subtitles/" + (_vm.osfile.res.split('.')[0].toLowerCase()) + "_" + (_vm.$i18n.locale) + ".vtt")
        },
        autoplay: false
      }}})],1):_vm._e(),_vm._l((_vm.osfile.contents[parseInt(_vm.$t('code'))]),function(item,index){return _c('div',{key:((_vm.$route.params.id) + "_" + (_vm.$i18n.locale) + "_" + index)},[(item.type=='text')?_c('div',{staticClass:"hint",domProps:{"innerHTML":_vm._s(item.content)}}):_vm._e(),(item.type=='movie')?_c('div',{staticClass:"video"},[_c('VideoPlayer',{attrs:{"options":{
          video: {
            url: ("./videos/" + (item.attrs[0]) + ".mp4")
          },
          subtitle: {
            url: ("./data/subtitles/" + (item.attrs[0].toLowerCase()) + "_" + (_vm.$i18n.locale) + ".vtt")
          },
          autoplay: false
        }}})],1):_vm._e(),(item.type=='bgm')?_c('div',{staticClass:"audio"},[_c('AudioPlayer',{attrs:{"theme":"#2d303a","music":{
          pic: './empty.png',
          src: ("./audios/bgms/" + (item.attrs[0].toLowerCase()) + ".mp3"),
          loop: 'one',
          mutex: false,
          title: _vm.$t('os.bgm'),
          artist: item.attrs[0],
        },"preload":""}})],1):_vm._e(),(item.type=='sound')?_c('div',{staticClass:"audio"},[_c('AudioPlayer',{attrs:{"theme":"#2d303a","music":{
          pic: './empty.png',
          src: ("./audios/sounds/" + (item.attrs[0].toLowerCase()) + ".mp3"),
          loop: 'none',
          mutex: false,
          title: item.attrs[1],
          artist: item.attrs[0],
        },"preload":""}})],1):_vm._e(),(item.type=='image')?_c('div',{staticClass:"image"},[_c('img',{attrs:{"alt":item.attrs[0],"src":("./images/osfiles/" + (item.attrs[0].toLowerCase()) + ".jpg")},on:{"click":function (){ return _vm.viewImage(("./images/osfiles/" + (item.attrs[0].toLowerCase()) + ".jpg")); }}})]):_vm._e(),(item.type=='json')?_c('JsonObject',{attrs:{"raw":item}}):_vm._e(),(item.type=='mail')?_c('MailObject',{attrs:{"title":item.attrs[0],"from":item.attrs[1],"to":item.attrs[2],"content":item.content}}):_vm._e(),(item.type=='conversation')?_c('TextObject',{attrs:{"name":item.attrs[0],"content":item.content}}):_vm._e()],1)})],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }